import React from 'react';
import './nav-bar.scss';
import NavLink from 'react-router-dom/NavLink';
import ShipslandLogo from '../../assets/Shipsland-Logo.jpg';
export default function() {
    return(
        <div className="general-nav">
        <ul className="nav">
            <div className="left">
                <li>
                    <NavLink className="brand" to="/" activeClassName="navlink-active">
                        <h1><img alt={'shipsland=logo'} src={ShipslandLogo}/></h1>
                    </NavLink>
                </li>
                {/*
                <li>
                    <NavLink className="link" to="/free" activeClassName="navlink-active">Try for Free</NavLink>
                </li>
                <li>
                    <NavLink className="link" to="/business" activeClassName="navlink-active">Business Plan</NavLink>
                </li>
                */}
            </div>
            <div className="right">
                <li>
                    <NavLink className="link" to="/Login" activeClassName="navlink-active">Login</NavLink>
                </li>
                <li>
                    <NavLink className="link" to="/create-account" activeClassName="navlink-active">Signup</NavLink>
                </li>
            </div>
        </ul>
    </div>
    )
}